import React, { Component } from 'react';
import PropTypes from 'prop-types';


class EstimateContent extends Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			max: 0,
			min: 0,
			sum: 0,
			genConCost: 0,
			furnishCost: 0,
			buildCost: 0,
			errors: [],
			email: {}
		}
	}

	gridDefinitionList(id, lines, estimates) {
		// The id of the budget item is passed in,
		// From here we look through the list of line items
		// and estimates for anything with the id passed in
		// if we find a matching item in both arrays this is
		// our cue to parse the item and output a budget item
		const key = "li" + id;
		const line = lines[key];
		const estimate = estimates[key];
		if(estimate !== undefined && estimate !== null
			&& line !== undefined && line.status !== "pending") {
			return (
				<div className="row" key={key}><div className="col">
					{/* In most cases the element in the [0] position will
					 be an introduction... so it's safe to grab the title here. */}
					<h5>{line.items[0].item_title}</h5>
				<dl>
				{line.items.map((item, index, readOnlyArrayOfItems) =>{
					index = Number(index);
					if(item.item_type === "fieldGrid" && item.grid.length > 0) {
						// Anytime we have a field grid on an item iteration
						// we check the following item to see if it's a slider
						// if we find a slider we stop parsing this grid item and
						// parse it with the slider. This is done because the slider
						// will multiply that value of the grid item.
						if(readOnlyArrayOfItems[Number(index)+1] !== undefined &&
							readOnlyArrayOfItems[Number(index)+1].item_type === "slider") {
								return null; // This item is parsed below with the slider.
						} else {
							// This is a plain grid that isn't multiplied by a slider
							return item.grid.map((obj, i) => {
								if(estimate[index].selectedValues === null || estimate[index].selectedValues.length < 1) {
									// It's null... do nothing
								} else {
									let dd = '';
									switch(obj.cost_basis) {
										case 'assoc' :
											dd = estimate[index].selectedValues[i] === undefined ? "No" :
											estimate[index].selectedValues[i] === 0 ? "No" : "Yes";
										break;
										case 'sqft' :
											dd = estimate[index].selectedValues[i] === undefined ? "No" :
											estimate[index].selectedValues[i] === 0 ? "No" : "Yes";
										break;
										case 'flat' :
											dd = estimate[index].selectedValues[i] === undefined ? "No" :
											estimate[index].selectedValues[i] === 0 ? "No" : "Yes";
										break;
										case 'healthcare' :
											dd = estimate[index].selectedValues[i] === undefined ? "No" :
											estimate[index].selectedValues[i] === 0 ? "No" : "Yes";
										break;
										default : // unit
											dd = estimate[index].selectedValues[i] === undefined ? "0" :
											estimate[index].selectedValues[i] === 0 ? "0" : estimate[index].selectedValues[i] + " ";
										break;
									}
									return (
										<React.Fragment key={key + "a" + index + "_" + i}>
											<dt>{obj.title}</dt>
											<dd>{dd}</dd>
										</React.Fragment>
									)
								}
							});
						}
					} else if(item.item_type === "slider") {
						// This side of the if/else handles sliders when they relate to grids.
						// When working with a slider remember that the slider reports it's value as on the
						// first step as "1", because everything else operates on a zero index we subtract
						// '1' from the value of the slider.
						const sel = estimates[key][index].selectedSliderIndex === null ? 0 : estimates[key][index].selectedSliderIndex-1;
						const stop = readOnlyArrayOfItems[index].slider.stops[sel];
						if(readOnlyArrayOfItems[index-1] !== undefined &&
							readOnlyArrayOfItems[index-1].item_type === "fieldGrid" &&
							estimates[key][index-1] !== undefined) {

								const gridItem = readOnlyArrayOfItems[index-1];
								const gridEst = estimates[key][index-1];
								return gridItem.grid.map((gGridItem, gI) =>  {
									if(gridEst.selectedValues[gI] !== undefined && Number(gridEst.selectedValues[gI]) > 0) {
										// this.appendLine(internalMandatories, gridItem.item_title + ", " + gridItem.grid[gI].title + " - " + sliderText.title,
										// Number(gridItem.grid[gI].base_cost)*Number(sliderText.stop_multiplier),
										// Number(gridItem.grid[gI].base_cost)*Number(sliderText.stop_multiplier)
										// 	*Number(gridEst.selectedValues[gI]) )
										return (

											<React.Fragment key={key + "a" + index}>
											<dt>{readOnlyArrayOfItems[index-1].item_title + " - " + stop.title}</dt>
											<dd>{gridEst.selectedValues[gI]}</dd>
											</React.Fragment>
										)
									} else {
										return null;
									}
								});

						} else {
							// This is a normal slider
							// start by getting the selection from our estimate

							return (
								<React.Fragment key={key + "a" + index}>
								<dt>{item.item_title}</dt>
								<dd>{stop.title}</dd>
								</React.Fragment>
							)
						} // This ends the slider logic relationship to grid if...else...
					} else {
						return null; // This is most likely an introduction component.
					}
				})}
				</dl>
				</div>
				</div>
			)
		} else {
			return;
		}
	}

	componentDidMount() {
		const csum = this.calcSum(this.props.estimates, this.props.lines, this.props.mandatories, this.props.calculator);
		if(csum.cost !== this.state.sum) {
			this.setState({min: csum.cost*.95, max: csum.cost*1.05, sum: csum.cost, genConCost: csum.genConCost, furnishCost: csum.furnishCost, buildCost: csum.buildCost});
		}
	}

	componentDidUpdate(prevProps) {
		const csum = this.calcSum(this.props.estimates, this.props.lines, this.props.mandatories, this.props.calculator);
		if(this.state.sum !== csum.cost) {
			this.setState({min: csum.cost*.95, max: csum.cost*1.05, sum: csum.cost, genConCost: csum.genConCost, furnishCost: csum.furnishCost, buildCost: csum.buildCost});
		}
	}

	calcSum(estimates, lineItems, mandatories, budget) {
		let cost = 0;
		let genConCost = 0;
		let finishLevelCost = 0;
		let furnishDesignCost =0;
		let furnishInstallCost = 0;

		let buildCost = 0;
		let buildCostGenCon = 0;
		let buildCostFurnishInstall = 0;

		let furnishCost = 0;
		let furnishCostGenCon = 0;
		let furnishCostFurnishInstall = 0;

		// healthcare general conditions costs add to a map of key value pairs
		let healthcareGenCost = new Map();

		const sqFt = mandatories.projectSqFt === "" ? Number(0) : mandatories.projectSqFt;
		const assoc = mandatories.associates === "" ? Number(0) : mandatories.associates;

		if( budget.lines.length > 0 ) {
			for( let boo in budget.lines) {
				let index = "li" + budget.lines[boo].id;
				if(estimates[index] !== undefined) {
					// now we found an element in the item repository with budget figures
					// lets dive and look at what actual item values are
					for(let key in lineItems[index].items){
						if(estimates[index][key] !== undefined) {
							key = Number(key);
							let item = lineItems[index].items[key];
							if(item.item_type === "fieldGrid") {

								// Heres the kicker... anytime we have a field grid
								// we check the following item to see if it's a slider
								// if we find a slider we stop parsing this grid item and
								// parse it with the slider.
								if(lineItems[index].items[key+1] !== undefined &&
									lineItems[index].items[key+1].item_type === "slider") {

										continue;
								} else {
									for( let wha in item.grid) {
										const val = item.grid[wha];
										var tmp = estimates[index][key].selectedValues[wha] === undefined
											? Number(0)
											: Number(estimates[index][key].selectedValues[wha]);

										if (this.props.calculator.id === 225) {

											for (let index = 0; index < this.props.budgets.length; index++) {
												var element = this.props.budgets[index];
												if (element.title.trim() == "Build") {
													var buildCalculatorBudget = element;
												}
											}

											for(var buildLn in buildCalculatorBudget.lines) {
												let buildID = "li" + buildCalculatorBudget.lines[buildLn].id;
												if (index === buildID) {
													if (item.apply_general_conditions === true) {
														switch(val.cost_basis) {
															case 'assoc' :
																buildCostGenCon += Number(val.base_cost) * tmp * assoc;
															break;
															case 'sqft' :
																buildCostGenCon += Number(val.base_cost) * tmp * sqFt;
															break;
															case 'flat' :
																buildCostGenCon += Number(val.base_cost) * tmp;
															break;
															default :
																buildCostGenCon += Number(val.base_cost) * tmp;
														}
													}
													if (item.apply_furnish_install === true) {
														switch(val.cost_basis) {
															case 'assoc' :
																buildCostFurnishInstall += Number(val.base_cost) * tmp * assoc;
															break;
															case 'sqft' :
																buildCostFurnishInstall += Number(val.base_cost) * tmp * sqFt;
															break;
															case 'flat' :
																buildCostFurnishInstall += Number(val.base_cost) * tmp;
															break;
															default :
																buildCostFurnishInstall += Number(val.base_cost) * tmp;
														}
													}
													switch(val.cost_basis) {
														case 'assoc' :
															buildCost += Number(val.base_cost) * tmp * assoc;
														break;
														case 'sqft' :
															buildCost += Number(val.base_cost) * tmp * sqFt;
														break;
														case 'flat' :
															buildCost += Number(val.base_cost) * tmp;
														break;
														default :
															buildCost += Number(val.base_cost) * tmp;
													}
												}
											}

											for (let index = 0; index < this.props.budgets.length; index++) {
												var element = this.props.budgets[index];
												if (element.title.trim() == "Furnish") {
													var furnishCalculatorBudget = element;
												}
											}

											for(var furnishLn in furnishCalculatorBudget.lines) {
												let furnishID = "li" + furnishCalculatorBudget.lines[furnishLn].id;
												if (index === furnishID) {
													if (item.apply_general_conditions === true) {
														switch(val.cost_basis) {
															case 'assoc' :
																furnishCostGenCon += Number(val.base_cost) * tmp * assoc;
															break;
															case 'sqft' :
																furnishCostGenCon += Number(val.base_cost) * tmp * sqFt;
															break;
															case 'flat' :
																furnishCostGenCon += Number(val.base_cost) * tmp;
															break;
															default :
																furnishCostGenCon += Number(val.base_cost) * tmp;
														}
													}
													if (item.apply_furnish_install === true) {
														switch(val.cost_basis) {
															case 'assoc' :
																furnishCostFurnishInstall += Number(val.base_cost) * tmp * assoc;
															break;
															case 'sqft' :
																furnishCostFurnishInstall += Number(val.base_cost) * tmp * sqFt;
															break;
															case 'flat' :
																furnishCostFurnishInstall += Number(val.base_cost) * tmp;
															break;
															default :
																furnishCostFurnishInstall += Number(val.base_cost) * tmp;
														}
													}
													switch(val.cost_basis) {
														case 'assoc' :
															furnishCost += Number(val.base_cost) * tmp * assoc;
														break;
														case 'sqft' :
															furnishCost += Number(val.base_cost) * tmp * sqFt;
														break;
														case 'flat' :
															furnishCost += Number(val.base_cost) * tmp;
														break;
														default :
															furnishCost += Number(val.base_cost) * tmp;
													}
												}
											}
										}

										if (item.apply_general_conditions === true) {
											switch(val.cost_basis) {
												case 'assoc' :
													genConCost += Number(val.base_cost) * tmp * assoc;
												break;
												case 'flat' :
													genConCost += Number(val.base_cost) * tmp;
												break;
												case 'sqft' :
													genConCost +=	Number(val.base_cost) * tmp * sqFt;
												break;
												default :
													genConCost +=	Number(val.base_cost) * tmp;
											}
										}

										if (item.apply_furnish_install === true) {
											switch(val.cost_basis) {
												case 'assoc' :
													furnishInstallCost += Number(val.base_cost) * tmp * assoc;
												break;
												case 'flat' :
													furnishInstallCost += Number(val.base_cost) * tmp;
												break;
												case 'sqft' :
													furnishInstallCost +=	Number(val.base_cost) * tmp * sqFt;
												break;
												default :
													furnishInstallCost +=	Number(val.base_cost) * tmp;
											}
										}

										switch(val.cost_basis) {
											case 'assoc' :
												cost += Number(val.base_cost) * tmp * assoc;
											break;
											case 'flat' :
												cost += Number(val.base_cost) * tmp;
											break;
											case 'sqft' :
												cost +=	Number(val.base_cost) * tmp * sqFt;
											break;
											case 'healthcare' :
												healthcareGenCost.set(val.title, val.base_cost * tmp);
											break;
											default :
												cost +=	Number(val.base_cost) * tmp;
										}
									}
								}
							}

							if(item.item_type === 'slider') {
								// This side of the if/else handles sliders when they relate to
								// grids
								if(lineItems[index].items[key-1] !== undefined &&
									lineItems[index].items[key-1].item_type === "fieldGrid" &&
									estimates[index][key-1] !== undefined) {
										// When working with slider remember that the slider reports it's value as on the
										// first step as "1", because everything else operates on a zero index we subtract
										// '1' from the value of the slider.
										const sel = estimates[index][key].selectedSliderIndex === null ? 0 : estimates[index][key].selectedSliderIndex-1;
										const sliderText = lineItems[index].items[key].slider.stops[sel];
										const gridItem = lineItems[index].items[key-1];
										const gridEst = estimates[index][key-1];

										for(var gI in gridItem.grid) {
											if(gridEst.selectedValues[gI] !== undefined && Number(gridEst.selectedValues[gI]) > 0) {

												if (this.props.calculator.id == 225) {

													for (let index = 0; index < this.props.budgets.length; index++) {
														var element = this.props.budgets[index];

														if (element.title == "Build") {
															var buildCalculatorBudget = element;
														}
													}

													for(var buildLn in buildCalculatorBudget.lines) {
														let buildID = "li" + buildCalculatorBudget.lines[buildLn].id;
														if (index === buildID) {
															if (item.apply_general_conditions === true) {
																buildCostGenCon += Number(gridItem.grid[gI].base_cost)*Number(sliderText.stop_multiplier)
																	*Number(gridEst.selectedValues[gI]);
															}
															if (item.apply_furnish_install === true) {
																buildCostFurnishInstall += Number(gridItem.grid[gI].base_cost)*Number(sliderText.stop_multiplier)
																	*Number(gridEst.selectedValues[gI]);
															}
															buildCost += Number(gridItem.grid[gI].base_cost)*Number(sliderText.stop_multiplier)
																*Number(gridEst.selectedValues[gI]);
														}
													}

													for (let index = 0; index < this.props.budgets.length; index++) {
														var element = this.props.budgets[index];
														if (element.title.trim() == "Furnish") {
															var furnishCalculatorBudget = element;
														}
													}

													for(var furnishLn in furnishCalculatorBudget.lines) {
														let furnishID = "li" + furnishCalculatorBudget.lines[furnishLn].id;
														if (index == furnishID) {
															if (item.apply_general_conditions === true) {
																furnishCostGenCon += Number(gridItem.grid[gI].base_cost)*Number(sliderText.stop_multiplier)
																	*Number(gridEst.selectedValues[gI]);
															}
															if (item.apply_furnish_install === true) {
																furnishCostFurnishInstall += Number(gridItem.grid[gI].base_cost)*Number(sliderText.stop_multiplier)
																	*Number(gridEst.selectedValues[gI]);
															}
															furnishCost += Number(gridItem.grid[gI].base_cost)*Number(sliderText.stop_multiplier)
																*Number(gridEst.selectedValues[gI]);
														}
													}
												}

												if (item.apply_general_conditions === true) {
													genConCost += Number(gridItem.grid[gI].base_cost)*Number(sliderText.stop_multiplier)
														*Number(gridEst.selectedValues[gI]);
												}
												if (item.apply_furnish_install === true) {
													furnishInstallCost += Number(gridItem.grid[gI].base_cost)*Number(sliderText.stop_multiplier)
														*Number(gridEst.selectedValues[gI]);
												}
												cost += Number(gridItem.grid[gI].base_cost)*Number(sliderText.stop_multiplier)
													*Number(gridEst.selectedValues[gI]);
											}
										}


								} else {
									// This is a normal slider
									// start by getting the selection from our estimate
									try	{
										let sliderArrayPos = estimates[index][key].selectedSliderIndex === null ? 0 : estimates[index][key].selectedSliderIndex-1;
										if (this.props.calculator.id == 225) {

											for (let index = 0; index < this.props.budgets.length; index++) {
												var element = this.props.budgets[index];

												if (element.title == "Build") {
													var buildCalculatorBudget = element;
												}
											}

											for(var buildLn in buildCalculatorBudget.lines) {
												let buildID = "li" + buildCalculatorBudget.lines[buildLn].id;
												if (index == buildID) {
													if (item.apply_general_conditions == true) {
														buildCostGenCon += Number(item.slider.stops[sliderArrayPos].stop_multiplier)*sqFt;
													}
													if (item.apply_furnish_install == true) {
														buildCostFurnishInstall += Number(item.slider.stops[sliderArrayPos].stop_multiplier)*sqFt;
													}
													switch(item.item_title) {
														case 'Select Project Finish Level' :
														finishLevelCost = Number(item.slider.stops[sliderArrayPos].stop_multiplier)*sqFt;
														buildCost += Number(item.slider.stops[sliderArrayPos].stop_multiplier)*sqFt;
														break;
														case 'Select Level of Finish for Existing Walls ' :
															buildCost += Number(item.slider.stops[sliderArrayPos].stop_multiplier) * finishLevelCost;
															if (item.apply_general_conditions == true) {
																buildCostGenCon -=  Number(item.slider.stops[sliderArrayPos].stop_multiplier)*sqFt ;
																buildCostGenCon += Number(item.slider.stops[sliderArrayPos].stop_multiplier) * finishLevelCost
															}
														break;
														default :
															buildCost += Number(item.slider.stops[sliderArrayPos].stop_multiplier)*sqFt;
													}
												}
											}

											for (let index = 0; index < this.props.budgets.length; index++) {
												var element = this.props.budgets[index];
												if (element.title.trim() == "Furnish") {
													var furnishCalculatorBudget = element;
												}
											}

											for(var furnishLn in furnishCalculatorBudget.lines) {
												let furnishID = "li" + furnishCalculatorBudget.lines[furnishLn].id;
												if (index == furnishID) {
													if (item.apply_general_conditions == true) {
														furnishCostGenCon += Number(item.slider.stops[sliderArrayPos].stop_multiplier)*sqFt;
													}
													if (item.apply_furnish_install == true) {
														furnishCostFurnishInstall += Number(item.slider.stops[sliderArrayPos].stop_multiplier)*sqFt;
													}
													furnishCost += Number(item.slider.stops[sliderArrayPos].stop_multiplier)*sqFt;
												}
											}
										}

										if (item.apply_general_conditions == true) {
											genConCost +=  Number(item.slider.stops[sliderArrayPos].stop_multiplier)*sqFt ;
										}
										if (item.apply_furnish_install == true) {
											furnishInstallCost +=  Number(item.slider.stops[sliderArrayPos].stop_multiplier)*sqFt ;
										}

										switch(item.item_title) {
											case 'Select Project Finish Level' :
											finishLevelCost = Number(item.slider.stops[sliderArrayPos].stop_multiplier)*sqFt;
											cost +=  Number(item.slider.stops[sliderArrayPos].stop_multiplier)*sqFt ;
											break;
											case 'Select Level of Finish for Existing Walls ' :
												cost += Number(item.slider.stops[sliderArrayPos].stop_multiplier) * finishLevelCost;
												if (item.apply_general_conditions == true) {
													genConCost -=  Number(item.slider.stops[sliderArrayPos].stop_multiplier)*sqFt ;
													genConCost += Number(item.slider.stops[sliderArrayPos].stop_multiplier) * finishLevelCost
												}
											break;
											default :
												cost +=  Number(item.slider.stops[sliderArrayPos].stop_multiplier)*sqFt ;
										}
									} catch(e) {
										console.log(e);
									}
								}
							}
						}
					}
				}
			}
		}

		// add healthcare general conditions
	  for (const [k, v] of healthcareGenCost.entries()) {
	    let hcGenCost = cost * (v/100);
	    healthcareGenCost.set(k, hcGenCost);
	  }
	  for (const [k, v] of healthcareGenCost.entries()) {
	    cost += healthcareGenCost.get(k);
	  }

		// get the furnish design cost at $1 per sqFt, 2500 min
		if (this.props.calculator.id == 137 || this.props.calculator.title.trim() == "Healthcare") {
			// do nothing
		} else {
			if (this.props.mandatories.projectSqFt > 2500) {
				furnishDesignCost = this.props.mandatories.projectSqFt;
			} else {
				furnishDesignCost = 2500;
			}
		}

		// add the furnish design cost where the cost is $2500 min or $1 per sqFt
		cost += furnishDesignCost;
		furnishCost += furnishDesignCost;

		// add the furnish install cost to cost and subTotals
		cost += (furnishInstallCost * .05);
		// buildCost += (buildCostFurnishInstall * .05);
		furnishCost += (furnishCostFurnishInstall * .05);

		let xVar = this.props.mandatories.projectSqFt * 5.75;
		// add the general condition costs of the budgets
		if (genConCost > 0) {
			cost += (xVar + (genConCost * .10)) / 2;
		}
		if (buildCostGenCon > 0) {
			buildCost += (xVar + (buildCostGenCon * .10)) / 2;
		}
		if (furnishCostGenCon > 0) {
			furnishCost += (xVar + (furnishCostGenCon * .10)) / 2;
		}

		return {cost: cost, genConCost: genConCost, furnishCost: furnishCost, buildCost: buildCost};

	}

	isDesignBuildFurnish(cash) {
		if (this.props.calculator.id == 225) {
			return (
				<div className='row'>
					<div className='col'>
						<dl>
							<dt>Build Estimate</dt>
							<dd>{cash.format(Math.round(this.state.buildCost))}</dd>
							<dt>Furnish Estimate</dt>
							<dd>{cash.format(Math.round(this.state.furnishCost))}</dd>
						</dl>
					</div>
				</div>)
		} else {
			return false;
		}

	}

  render() {
		const {mandatories, lines, estimates, calculator, budgets} = this.props
		const cash =  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
		return (
			<div>
				<header className="calculator-header">
					<img src="/wp-content/uploads/2018/10/bsi-logo-notag-rgb.svg" alt='Logo' width='100' className='logo' />
					<h3>Budget for</h3>
					<h1>{mandatories.projectName}</h1>
				</header>
					<section className="estimate contact">
						<div className="row">
							<div className="col">
								<h4>Prepared for:</h4>
								<p>
									{mandatories.contactName}<br />
									{mandatories.company}<br/>
									{mandatories.contactEmail}<br />
									{mandatories.contactPhone}
								</p>
							</div>
							<div className="col">
								<h4>Prepared by:</h4>
								<p>
									{mandatories.representitiveName}<br />
									Building Service Inc.<br/>
									{mandatories.representitiveEmail}<br />
									262.955.6400
								</p>
							</div>
						</div>
					</section>
					<section className="estimate totals">
					<div className='row'>
						<div className='col'>
						<h2>{cash.format(Math.round(this.state.min/mandatories.projectSqFt))} —
							{cash.format(Math.round(this.state.max/mandatories.projectSqFt))}</h2>
							<p>Estimated cost per square foot</p>
						</div>
						<div className='col'>
							<h2>{cash.format(Math.round(this.state.min))} —
							{cash.format(Math.round(this.state.max))}</h2>
							<p>Estimated cost for project</p>
						</div>
					</div>
					</section>

					<section className='estimate'>
					<div className='row'>
						<div className='col'>
							<h3>Project Summary</h3>
							<h4>Overview</h4>
							<dl>
								<dt>Project Square Feet</dt>
								<dd>{new Intl.NumberFormat('en-US', { maximumSignificantDigits: 21 }).format(mandatories.projectSqFt)}</dd>

								<dt>Number of Associates</dt>
								<dd>{mandatories.associates}</dd>
							</dl>
						</div>
					</div>
					{this.isDesignBuildFurnish(cash)}
					<div className='row'><div className="col"><h4>Budget Areas</h4></div></div>
					{calculator.lines && calculator.lines.map(element => {
						// Start by taking each element in the budget and output a DL for it
						return this.gridDefinitionList(element.id, this.props.lines, this.props.estimates);
					})}

					<div className="subTotals">
					</div>

					<div className="estimate disclaimer">
						<h6>DISCLAIMER:</h6>
						<p>While every effort has been made to ensure that this Budget Calculator
						tool provides a realistic estimation of project costs, based on the
						data you selected, the results should be used as an indication of the
						estimated costs only. This tool does not provide a quote, and is not
						intended to be a substitute for quoting or quoting comparison tools;
						nor is it a substitute for quotes from BSI representatives. There are
						also other cost factors that may not be included in this tool. BSI
						representatives will be able to best provide you with more accurate
						costs based on your final specifications.</p>
						<p>Your use of BSI’s Budget Calculator tool is solely at your own risk.
						BSI shall not have any liability (whether direct, indirect,
						incidental, consequential, special, exemplary, or the like) to
						you or any other part arising in any way from your use of, or
						inability to use, the Budget Calculator Tool.</p>
					</div>

				</section>
			</div>
		)
	}
}

EstimateContent.propTypes = {
	mandatories: PropTypes.object.isRequired,
	lines: PropTypes.object,
	estimates: PropTypes.object.isRequired,
	calculator: PropTypes.object.isRequired,
	budgets: PropTypes.array
};


export default EstimateContent;



// WEBPACK FOOTER //
// ./src/components/estimate/EstimateContent.js